<template>
  <div v-if="experiences.length > 0" class="extra-experience-component">
    <h2 class="text-secondary">
      {{ $t('ETAB.PAGES.EXTRA.@EXPERIENCES_TITLE') }}
    </h2>
    <IconBoxWrapper
v-for="experience in experiences"
                    :key="experience.id"
                    borderless
                    icon-background="secondary"
                    icon="icon-f-briefcase"
                    icon-color="white"
                    icon-size="25px"
                    radius
                    shadow
    >
      <article>
        <header>
          <b>{{ experience.getQualificationLabel() }}</b>
          <StarsNotation :note="experience[IExperience.note]" stars-color="secondary" />
        </header>
        <section class="extra-experience-etab">
          {{ getEtabDisplay(experience) }}
        </section>
        <section class="extra-experience-contract">
          {{ getContractDisplay(experience) }}
        </section>
        <section v-if="experience[IExperience.comment]" class="extra-experience-comment">
          <p class="extra-comment-quotes">
            {{ experience[IExperience.comment] }}
          </p>
        </section>
      </article>
    </IconBoxWrapper>
  </div>
</template>

<script>
import { ExtraModel, IExperience } from "@core/models";
import StarsNotation from "@core/components/common/StarsNotation.component.vue";

export default {
  components: {
    StarsNotation,
  },
  props: {
    extra: {
      type: Object,
      default: () => new ExtraModel(),
    },
  },
  computed: {
    experiences() {
      return this.extra.getExperiences() || [];
    },
  },
  created() {
    this.IExperience = IExperience;
  },
  methods: {
    getEtabDisplay(experience) {
      const etabName = experience.getEtab().name;
      const etabType = experience.getEtab().type;
      const type = etabType ? `, ${etabType}` : "";
      return `${etabName}${type}`;
    },
    getContractDisplay(experience) {
      const contract = experience.getContract().contract;
      const start = experience.getContract().start;
      const end = experience.getContract().end;

      let display = contract;
      display += start ? `, ${start}` : "";
      display += start && end ? ` ${this.$t("ETAB.PAGES.EXTRA.@EXPERIENCES_CONTRACT_END_DATE")} ${end}` : "";

      return display;
    },
  },
};
</script>

<style lang="scss">
.extra-experience-component {
  margin-top: 40px;

  h2 {
    margin: 0;
  }

  .extra-icon-box-wrapper {
    margin: 25px 0;
  }

  article {
    padding: 10px 15px;

    > header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;
    }

    .extra-experience-etab,
    .extra-experience-contract {
      color: $grey;
      line-height: 1.25;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-bottom: 5px;
    }

    .extra-experience-comment {
      margin-top: 10px;
      padding: 10px;
      background-color: $body-background-light-grey;

      p {
        margin: 0;
      }
    }
  }
}
</style>
